module.exports = __webpack_public_path__ + "img/blog-54.064072e2.jpg";